import "./ProviderDataStyle.css";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
} from "@mui/material";

export default function HYCOM_V02() {
  return (
    <>
      <div className="dialogWarning">
        MIKE Data Link carries out comprehensive quality control checks on all
        third-party datasets. However, errors and inconsistencies inherited from
        these datasets (for example, missing values) may appear as errors in
        extracted data. If you encounter incorrect values such as NaN or
        erroneous zero values in extracted boundary conditions, initial
        conditions, or forcings output files, please contact{" "}
        <a href="mailto:mike@dhigroup.com">mike@dhigroup.com.</a>
      </div>
      <div className="dialogSummary">
        The data set from HYCOM (Hybrid Coordinate Ocean Model) include
        global-scale ocean model data. HYCOM is a consortium of
        multi-institutional effort sponsored by the National Ocean Partnership
        Program (NOPP), as part of the U. S. Global Ocean Data Assimilation
        Experiment (GODAE), to develop and evaluate a data-assimilative hybrid
        coordinate ocean model.
        <br /><br/>
        HYCOM GOFS 3.1 was replaced by HYCOM ESPC-D-V02 on 5 September 2024.
        Instead of extending our existing HYCOM data set with HYCOM ESPC-D-V02,
        we have decided to offer ESPC-D-V02 as a new data set. Because
        ESPC-D-V02 includes diurnal tidal variation, it's not compatible with
        GOFS 3.1, which did not. Users who want to combine data from ESPC-D-V02
        with earlier HYCOM data should create combined HYCOM/DTU10 Tide files
        and then extend these with ESPC-D-V02 to create a consistent record.
      </div>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              General
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Title</TableCell>
            <TableCell>ESPC-D-V02: Global 1/12° Analysis</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Coverage</TableCell>
            <TableCell>Global</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Category</TableCell>
            <TableCell>Ocean Parameters</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Source Name</TableCell>
            <TableCell>
              ESPC-D-V02: Global 1/12° Analysis output on the GLBy0.08 grid
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Publisher</TableCell>
            <TableCell>
              Fleet Numerical Meteorology and Oceanography Center (FNMOC)
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Cost (ex. VAT)</TableCell>
            <TableCell>Free</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Typical Applications</TableCell>
            <TableCell>Hydrodynamic, Offshore and Marine projects</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>References</TableCell>
            <TableCell>
              <a
                href="https://www.hycom.org/"
                target="_blank"
                rel="noopener noreferrer"
              >
                HYCOM home
              </a>
              <br />
              <a
                href="https://www.hycom.org/dataserver/espc-d-v02/global-analysis"
                target="_blank"
                rel="noopener noreferrer"
              >
                ESPC-D-V02: Global 1/12° Analysis (Dataset)
              </a>
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Coverage
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Geographical Range</TableCell>
            <TableCell>
              Global:
              <br />
              Longitude: 180°W -&gt; 180°E
              <br />
              Latitude: 80°S -&gt; 90°N
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Geographical Resolution</TableCell>
            <TableCell>
              GLBy0.08: <br />
              0.08 deg. Long x 0.04 deg. Lat
              <br />
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Reference</TableCell>
            <TableCell>Sea surface</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Range</TableCell>
            <TableCell>Sea surface to Sea bed</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Vertical Resolution</TableCell>
            <TableCell>41 layers</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Reference</TableCell>
            <TableCell>UTC</TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Range</TableCell>
            <TableCell>
              Data Link coverage:
              <br />
              GLBy0.08: 93: 10/08-2024 -&gt; Present
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Temporal Resolution</TableCell>
            <TableCell>
              3-hourly, except Sea Surface Height (1-hourly)
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Variables
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Name (Unit)</TableCell>
            <TableCell>
              Sea Surface Height [m]
              <br />
              Water Temperature [deg C]
              <br />
              Salinity [psu]
              <br />
              U-velocity component (East dir.) [m/s]
              <br />
              V-velocity component (North dir.) [m/s]
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>

      <Table className="dialogTable">
        <TableHead>
          <TableRow>
            <TableCell align="left" colSpan={2}>
              Credits
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <TableRow>
            <TableCell>Data product Authors and Originators</TableCell>
            <TableCell>
              DOC/NOAA/NWS/NCEP &gt; National Centers for Environmental
              Prediction, National Weather Service, NOAA, U.S. Department of
              Commerce
            </TableCell>
          </TableRow>
          <TableRow>
            <TableCell>Data product Publisher</TableCell>
            <TableCell>
              NOAA National Centers for Environmental Information.
              DOC/NOAA/NESDIS/NCDC &gt; National Climatic Data Center, NESDIS,
              NOAA, U.S. Department of Commerce
            </TableCell>
          </TableRow>
        </TableBody>
      </Table>
    </>
  );
}
